<script>
import Popper from 'popper.js';

export default {
  name: 'Popper',
  props: {
    config: {
      type: Object,
      default: () => ({ placement: 'bottom' }),
    },
  },
  data() {
    return {
      isOpen: false,
      triggerEl: null,
      popperEl: null,
    };
  },
  beforeDestroy() {
    if (!this.popper) {
      return;
    }

    this.popper.destroy();
  },
  mounted() {
    this.triggerEl = this.$el.querySelector('[data-trigger]');
    this.popperEl = this.$el.querySelector('[data-popper]');
  },
  methods: {
    open() {
      if (this.isOpen) {
        return;
      }

      this.isOpen = true;
      this.$nextTick(() => {
        this.setupPopper();
      });
    },
    close() {
      if (!this.isOpen) {
        return;
      }

      this.isOpen = false;
    },
    setupPopper() {
      if (this.popper === undefined) {
        this.popper = new Popper(this.triggerEl, this.popperEl, this.config);
      } else {
        this.popper.scheduleUpdate();
      }
    },
  },
  render() {
    return this.$scopedSlots.default({
      isOpen: this.isOpen,
      open: this.open,
      close: this.close,
    });
  },
};
</script>
<style>
[x-placement] [x-arrow] {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 0.5rem;
}

[x-placement^='top'] {
  margin-bottom: 0.5rem;
}

[x-placement^='top'] [x-arrow] {
  border-width: 0.5rem 0.5rem 0 0.5rem;
  border-left-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  bottom: -0.5rem;
  left: calc(50% - 0.5rem);
  margin-top: 0;
  margin-bottom: 0;
}

[x-placement^='bottom'] {
  margin-top: 0.5rem;
}

[x-placement^='bottom'] [x-arrow] {
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-left-color: transparent;
  border-right-color: transparent;
  border-top-color: transparent;
  top: -0.5rem;
  left: calc(50% - 0.5rem);
  margin-top: 0;
  margin-bottom: 0;
}

[x-placement^='right'] {
  margin-left: 0.5rem;
}

[x-placement^='right'] [x-arrow] {
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-left-color: transparent;
  border-top-color: transparent;
  border-bottom-color: transparent;
  left: -0.5rem;
  top: calc(50% - 0.5rem);
  margin-left: 0;
  margin-right: 0;
}

[x-placement^='left'] {
  margin-right: 0.5rem;
}

[x-placement^='left'] [x-arrow] {
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  right: -0.5rem;
  top: calc(50% - 0.5rem);
  margin-left: 0;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomTooltip.vue